import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { ProjectTypesType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { PROJECT_TYPES } from "../../utils/constants";

export const createProjectType = async (data: ProjectTypesType) => await post<ProjectTypesType, string>(PROJECT_TYPES, data);
export const updateProjectType = async (data: ProjectTypesType) => await put<ProjectTypesType, string>(PROJECT_TYPES, data);

export const getProjectTypes = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${PROJECT_TYPES}?${queryParams.toString()}`;
    return await get<PagedResultsType<ProjectTypesType>>(url);
};
